import React, { useRef, useEffect } from "react";

const LinkDialog = ({ open, onClose, onConfirm, title, inputValue, setInputValue }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (open) {
      dialog.showModal();
    } else if (dialog?.open) {
      dialog.close();
    }
  }, [open]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  const handleConfirm = () => {
    onConfirm(inputValue);
  };

  return (
    <>
      {open && <div className="dialog-overlay" onClick={onClose}></div>}
      <dialog ref={dialogRef} className="dialog-container2" onCancel={onClose}>
        <div className="dialog-content">
          <h2 className="dialog-title" style={{ padding: "0.46vh 0", fontSize: "1.8vh", fontWeight: "600", letterSpacing: "0.024vh" }}>{title}</h2>
          <input
            type="url"
            placeholder="Enter your link"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            required
            autoFocus
            className="dialog-input"
            style={{ width: "100%", padding: "1.2vh 1.2vw", fontSize: "1.6vh", marginBottom: "1.6vh" }}
          />
          <div className="dialog-actions" style={{ padding: "1.39vh 0"}}>
            <button onClick={onClose} className="dialog-button dialog-cancel">
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="dialog-button dialog-confirm2"
            >
              Save
            </button>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default LinkDialog;
